import { useTitle } from '@flippingbook/web.react-hooks/dist/useTitle';
import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import { Link as KitLink } from '@flippingbook/web.react-kit/dist/Link';
import { Paper } from '@flippingbook/web.react-kit/dist/Paper';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { loc } from '@/localization';
import { analyticsService } from '@/services/instance/analytics';
import { discoveryService } from '@/services/instance/discovery';
import { getSamlErrorMessage, getSamlErrorType, SamlErrorType } from '@/utils/get-saml-error-message';

import { b, e } from '../Login/style.css';

import errorIcon from './assets/error.svg';

const siteUrl = discoveryService.get('site');

const samlErrorToEventMap: Record<SamlErrorType, string> = {
    [SamlErrorType.SubuserLimitExceeded]: 'Limit is exceeded',
    [SamlErrorType.InviterLicenseExpired]: 'License is expired',
    [SamlErrorType.InviteeHasOwnLicense]: 'Already has FBO license',
    [SamlErrorType.IdpNotFound]: 'SAML ID is not enabled',
    [SamlErrorType.ResponseMissing]: 'Response Missing',
    [SamlErrorType.Other]: 'Other',
};

export function SamlErrorPage() {
    useTitle(loc.Main.AccountPageTitle.replace('{0}', loc.Login.SamlErrorTitle));

    const { idp = '' } = useParams();

    const errorType = useMemo(() => getSamlErrorType(), []);

    const { text, contactsSubject } = getSamlErrorMessage(errorType);

    const subject = contactsSubject ? `&subject=${encodeURIComponent(contactsSubject)}` : '';

    useEffect(() => {
        void analyticsService.sendSsoLoginErrorEvent({
            errorType: samlErrorToEventMap[errorType],
            domain: idp,
        });
    }, [errorType, idp]);

    return (
        <div className={b.name}>
            <Paper
                className={e.card}
                radius="large"
            >
                <img
                    className={e.cardIcon}
                    src={errorIcon}
                    alt=""
                />
                <h1 className={e.title2}>{loc.Login.SamlErrorTitle}</h1>
                <p className={e.errorDescription}>
                    <L10n
                        text={text}
                        replaces={[
                            [
                                '{us}',
                                <KitLink href={`${siteUrl}contacts?contact-form=support${subject}`}>
                                    {loc.Login.SamlErrorUs}
                                </KitLink>,
                            ],
                        ]}
                    />
                </p>
            </Paper>
        </div>
    );
}
